export default {
  "hash": "e209404",
  "raw": "v3.29.0",
  "semverString": "3.29.0"
};